import type { DetectedPetContent, EvidenceUploadMode, PETComposition, SimpleMaterialQualityCategory } from 'api';
import { AIModelChoices } from 'api';
import { useTranslation } from 'i18n';
import { Link } from 'react-router-dom';
import { DataCard } from 'ui';
import { Insights } from 'ui/icons';

import { AdminAiVersionTitle } from '../../../breakdowns/components/AdminAiVersionTitle/AdminAiVersionTitle';
import { NoAnalysisAlert } from '../../../breakdowns/components/NoAnalysisAlert/NoAnalysisAlert';
import { PETCompositionBreakdown } from '../../../breakdowns/components/PETCompositionBreakdown/PETCompositionBreakdown';
import { RepresentativeEvidenceSection } from '../../../breakdowns/components/PETRepresentativeEvidenceSection/PETRepresentativeEvidenceSection';

type Props = {
  detectedPetContent?: DetectedPetContent;
  petComposition?: PETComposition;
  isLoading?: boolean;
  parentId?: number;
  uploadMode?: EvidenceUploadMode;
  sessionLink?: string;
  sessionName?: string;
  modelName?: AIModelChoices;
  latestRunAIVersion?: string;
  materialCategory?: Pick<SimpleMaterialQualityCategory, 'id' | 'name'> | null;
};

export const PETCompositionDataCard = ({
  detectedPetContent,
  isLoading,
  petComposition,
  parentId,
  uploadMode,
  sessionLink,
  sessionName,
  modelName,
  latestRunAIVersion,
  materialCategory,
}: Props) => {
  const { t } = useTranslation('features');
  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          avatar: <Insights />,
          title: (
            <AdminAiVersionTitle
              title={t('dataCards.petComposition.aiBaleAnalysisTitle')}
              version={latestRunAIVersion}
            />
          ),
        },
      }}
    >
      {sessionLink && sessionName ? (
        <DataCard.Item title={t('dataCards.petComposition.reportTitle')} colSpan={6}>
          <Link to={sessionLink}>{sessionName}</Link>
        </DataCard.Item>
      ) : null}
      <DataCard.Item colSpan={12}>
        {petComposition ? (
          <PETCompositionBreakdown composition={petComposition} modelName={modelName} />
        ) : (
          <NoAnalysisAlert aiModel="pet" />
        )}
      </DataCard.Item>

      {detectedPetContent ? (
        <DataCard.Item colSpan={12}>
          <RepresentativeEvidenceSection
            detectedContent={detectedPetContent}
            parentId={parentId}
            uploadMode={uploadMode}
            materialCategory={materialCategory}
          />
        </DataCard.Item>
      ) : null}
    </DataCard>
  );
};
